module.exports = __webpack_public_path__ + "img/f2a35f4aa34d266aecd8c9779cf6261b.png";